import { makeStyles } from '@material-ui/core';

export default makeStyles((theme) => ({
  extension: {
    paddingTop: theme.spacing(3.5),
    paddingLeft: theme.spacing(1),
  },
}));
